<template>
  <div class="cc-nav">
    <div class="cc-nav-item" v-for="nav in navList" :key="nav.name" @click="handleNavClick(nav)">
      <cc-svg-icon :icon-class="nav.icon" :className="nav.active ? 'active':'no-active'" size="25"></cc-svg-icon>
      <p class="nav-name" :class="nav.active ? 'active':''">{{nav.name}}</p>
      <span
        v-if="nav.info"
        :class="[totalNum>10?'fz6':'fz10']"
        class="nav-info"
      >{{totalNum>99?" 99+":totalNum}}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ResultCode } from '~const/ResultCode'
export default {
  name: 'cc-nav',
  data () {
    return {
      navList: [
        {
          name: '首页',
          icon: 'home',
          path: '/home',
          redirect: false,
          active: false
        },
        {
          name: '快捷采购',
          icon: 'feature',
          // path: '/product/categorylist?goback=1',
          path: '/categorylist',
          redirect: false,
          // redirect: true,
          active: false
        },
        {
          name: '采购车',
          icon: 'car',
          path: '/shopping-cart/purchase',
          redirect: false,
          info: true,
          active: false
        },
        {
          name: '管理中心',
          icon: 'me',
          // path: '/user/index?goback=1',
          // path: '/aboutus/news-list#/management',
          path: '/management',
          redirect: false,
          active: false
        }
      ],
      // 登录的状态
      islogin: '',
      // 登录的角色
      role: ''
    }
  },
  computed: {
    ...mapGetters(['getGoodsTotalNum', 'getLoginStatus', 'getCartnum']),
    totalNum () {
      // return 0
      if (this.islogin.toString() === '0') {
        return 0
      } else {
        if (this.role.toString() === '3') {
          return this.getGoodsTotalNum.quantity
        } else {
          return this.getCartnum
        }
      }
    }
  },
  methods: {
    handleNavClick (nav) {
      /**
       * @description 兼容老页面。老页面使用 localtion 跳转，新页面使用router 跳转
       */
      if (nav.redirect) {
        location.href = nav.path
      } else {
        this.$router.push(nav.path)
      }
    }
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler (to, from) {
        setTimeout(() => {
          this.navList.forEach(item => {
            item.active = false
          })
          this.navList.forEach(item => {
            if (item.path.includes(to.path)) {
              item.active = true
            }
          })
        }, 50)
      }
    },
    getLoginStatus: {
      deep: true,
      immediate: true,
      handler (newValue, oldValue) {
        if (newValue) {
          let { status, data } = newValue
          this.islogin = data.member_id
          this.role = data.role
          if (status === ResultCode.SUCCESS) {
            if (data.member_id.toString() !== '0') {
              // 登录角色 1 采购商 2 供应商   3 分销商
              if (['1', '2'].includes(data.role.toString())) {
                this.navList[2].name = '采购车'
                this.navList[2].path = '/shopping-cart/purchase'
              } else {
                this.navList[2].name = '采购单'
                this.navList[2].path = '/shopping-cart/distributor'
              }
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~styles/mixins.scss";
.cc-nav {
  height: 100%;
  @include center(row);
  box-shadow: 0 -2px 4px rgba(235, 233, 233, 0.44);
  &-item {
    flex: 1;
    position: relative;
    @include center(column);
    .nav-name {
      padding-top: 3px;
      font-size: 10px;
      color: #777;
    }
    .nav-info {
      background: var(--APP_theme_color);
      display: inline-block;
      height: 16px;
      width: 16px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      position: absolute;
      top: 0;
      right: 15px;
    }
    .active {
      color: var(--APP_theme_color);
    }
    .no-active {
      color: #bfbfbf;
    }
    .fz10 {
      font-size: 10px;
    }
    .fz6 {
      font-size: 6px;
    }
  }
}
</style>
